module.exports = __webpack_public_path__ + "static/media/Will-it-rain.66fd67e5.jpeg";